<template>
  <form @submit.prevent="submit">
    <FormMessage :errors="errors" v-if="errors" />
    <FormInput
      name="email"
      v-model="forgotPasswordFields.email"
      testId="email-input"
      placeholder="Email"
      label="Email *"
      :errors="validation.fields.email.errors"
      :dirty="validation.fields.email.dirty"
    />
    <div class="form-actions">
      <Btn
        variant="primary"
        type="submit"
        :disabled="!isSubmittable"
        :loading="isSubmitting"
        @click="submit"
        data-test="reset-button"
        >Reset</Btn
      >
    </div>
  </form>
</template>

<script>
import { computed, reactive, ref } from "vue";
import Btn from "@/components/display/Btn";
import FormInput from "@/components/display/form/FormInput";
import FormMessage from "@/components/display/form/FormMessage";
import { fromServer } from "@/utils/translations";
import store from "@/store";
import useValidator from "@/utils/useValidator";
import { validations as validationRules } from "leatherman-js";

export default {
  name: "ForgotPasswordForm",
  components: {
    Btn,
    FormInput,
    FormMessage,
  },
  setup(props, { emit }) {
    const errors = ref(null);
    const isSubmitting = ref(false);

    const isSubmittable = computed(
      () => !isSubmitting.value && validation.errors.length === 0 && validation.fields.email.dirty
    );

    const forgotPasswordFields = reactive({ email: null });
    const { validator } = useValidator();
    const validation = validator(
      forgotPasswordFields,
      validationRules.forms.forgotPassword,
      {},
      {
        email: {
          required: "Email address is required",
          email: "Invalid Email",
        },
      }
    );

    const submit = () => {
      errors.value = null;

      validation.validate().then(() => {
        isSubmitting.value = true;
        store
          .dispatch("auth/forgotPassword", forgotPasswordFields.email)
          .then(() => emit("success"))
          .catch(
            (e) =>
              (errors.value =
                e.request.status === 403
                  ? ["This user is not allowed to start a password reset."]
                  : fromServer(e.request.response))
          )
          .finally(() => (isSubmitting.value = false));
      });
    };

    return {
      errors,
      forgotPasswordFields,
      isSubmittable,
      isSubmitting,
      submit,
      validation,
    };
  },
};
</script>
